/** Continuous tile-size setting: 0 (dense/small) → 100 (sparse/large). */
export const GRID_DENSITY_MIN = 0;
export const GRID_DENSITY_MAX = 100;

const MIN_TILE_WIDTH = 120;
const MAX_TILE_WIDTH = 300;
const MIN_THUMB = 90;
const MAX_THUMB = 240;
const MIN_ROW = 140;
const MAX_ROW = 300;
const MIN_FOLDER_ICON = 88;
const MAX_FOLDER_ICON = 160;

export function clampGridDensity(raw) {
  const n = Number.parseInt(raw, 10);
  if (!Number.isFinite(n) || n <= 0) {
    return GRID_DENSITY_MIN;
  }
  return Math.min(GRID_DENSITY_MAX, n);
}

function lerp(min, max, density) {
  return Math.round(min + (clampGridDensity(density) / GRID_DENSITY_MAX) * (max - min));
}

export function gridDensityToMinTileWidth(density) {
  return lerp(MIN_TILE_WIDTH, MAX_TILE_WIDTH, density);
}

export function gridDensityToThumbMax(density) {
  return lerp(MIN_THUMB, MAX_THUMB, density);
}

export function gridDensityToRowHeight(density) {
  return lerp(MIN_ROW, MAX_ROW, density);
}

export function gridDensityToFolderIconSize(density) {
  return lerp(MIN_FOLDER_ICON, MAX_FOLDER_ICON, density);
}
